import { createClient } from '@supabase/supabase-js'
import type { Database } from '@/types/database'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables')
}

// Cliente principal configurado para o schema grupod12
export const supabase = createClient<Database>(supabaseUrl, supabaseAnonKey, {
  db: {
    schema: 'grupod12'
  },
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true
  }
})

// Alias para manter compatibilidade
export const supabaseGrupoD12 = supabase

// IMPORTANTE: Use schemaQuery do arquivo schema-resolver.ts em vez dos clientes diretos
// Exemplos:
// - schemaQuery.table('vendas') em vez de supabase.from('vendas')
// - schemaQuery.view('v_dashboard_daily_total') em vez de supabase.from('v_dashboard_daily_total')
// - schemaQuery.rpc('force_refresh_marketing_data') em vez de supabase.rpc('force_refresh_marketing_data')